
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_145pa_37co1_93",
  "focus-lock": "awsui_focus-lock_145pa_37co1_104",
  "calendar": "awsui_calendar_145pa_37co1_108",
  "date-picker-container": "awsui_date-picker-container_145pa_37co1_121",
  "date-picker-trigger": "awsui_date-picker-trigger_145pa_37co1_126",
  "date-picker-input": "awsui_date-picker-input_145pa_37co1_130",
  "open-calendar-button": "awsui_open-calendar-button_145pa_37co1_135"
};
  